<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
      <v-row>
        <v-col cols="12" :md="'6'" class="pt-0 pb-1">
          <ValidationProvider
            name="Quote Type"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="quoteTypes"
              label="Quote Type"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="record.quoteType"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col
          cols="12"
          :md="6"
          class="pt-0 pb-1"
          v-if="!isProductQuote"
        >
          <ValidationProvider
            name="Location ID"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="record.locationId"
              label="Location ID"
              placeholder=" "
              outlined
              dense
              :readonly="false"
            ></v-text-field>
          </ValidationProvider>
        </v-col>

<!--        <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="!isProductQuote">-->
<!--          <ValidationProvider-->
<!--            name="Product Offering ID - Version"-->
<!--            :rules="'required'"-->
<!--            v-slot="{ errors }"-->
<!--          >-->
<!--            <v-combobox-->
<!--              :items="productOfferings"-->
<!--              label="Product Offering ID - Version"-->
<!--              outlined-->
<!--              placeholder=" "-->
<!--              :clearable="true"-->
<!--              v-model="record.productOffering"-->
<!--              :error-messages="errors"-->
<!--              dense-->
<!--              :readonly="false"-->
<!--            ></v-combobox>-->
<!--          </ValidationProvider>-->
<!--        </v-col>-->

        <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isProductQuote">
          <ValidationProvider
            name="After Hours Site Visit"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="afterHoursSiteVisit"
              label="After Hours Site Visit"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="record.afterHoursSiteVisit"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>


        <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isProductQuote">
          <ValidationProvider
            name="Service Restoration SLA"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="serviceRestorationSLA"
              label="Service Restoration SLA"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="record.serviceRestorationSLA"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isProductQuote">
          <ValidationProvider
            name="Contract Term"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="contractTerm"
              label="Contract Term"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="record.contractTerm"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isProductQuote">
          <ValidationProvider
            name="Cos Low Bandwidth"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="bandwidth"
              label="Cos Low Bandwidth"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="record.cosLowBandwidth"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isProductQuote">
          <ValidationProvider
            name="Cos Medium Bandwidth"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="bandwidth"
              label="Cos Medium Bandwidth"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="record.cosMediumBandwidth"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isProductQuote">
          <ValidationProvider
            name="Cos High Bandwidth"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="bandwidth"
              label="Cos High Bandwidth"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="record.cosHighBandwidth"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isProductQuote">
          <ValidationProvider
            name="Route Type"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="routeTypes"
              label="Route Type"
              outlined
              placeholder=" "
              :clearable="true"
              v-model="record.routeType"
              :error-messages="errors"
              dense
              :readonly="false"
            ></v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col
          cols="12"
          :md="6"
          class="pt-0 pb-1"
          v-if="!isProductQuote"
        >
          <ValidationProvider
            name="Customer Reference"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="record.reference"
              label="Customer Reference"
              placeholder=" "
              outlined
              dense
              :readonly="false"
            ></v-text-field>
          </ValidationProvider>
        </v-col>

        <v-col
          cols="12"
          :md="6"
          class="pt-0 pb-1"
          v-if="isProductQuote"
        >
          <ValidationProvider
            name="Quote Id"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="record.quoteId"
              label="Quote Id"
              placeholder=" "
              outlined
              dense
              :readonly="false"
            ></v-text-field>
          </ValidationProvider>
        </v-col>


      </v-row>

      <div class="text-right mb-7">
        <v-btn
          class="primary"
          @click="submit"
        >Submit</v-btn
        >
      </div>
    </ValidationObserver>
  </div>
</template>

<script>

export default {
  name: "quote-form",
  props:{
    isEditing: { type: Boolean },
    query:{type:Object}
  },
  data: () => ({
    record: {},
    // productOfferings:[
    //   { text: "TPL900000000001 - 1.1.0", value: "1.1.0", disabled: false },
    //   { text: "TPL900000000001 - 1.2.0", value: "1.2.0", disabled: false },
    // ],
    quoteTypes:[
      { text: "FBC Quote", value: "FBCQuoteItem", disabled: false },
      { text: "Product Quote", value: "ProductQuoteItem", disabled: false },
    ],
    routeTypes:[
      { text: "Local", value: "Local", disabled: false },
      { text: "State", value: "State", disabled: false },
    ],
    afterHoursSiteVisit:[
      { text: "Yes", value: "Yes", disabled: false },
      { text: "No", value: "No", disabled: false },
    ],
    serviceRestorationSLA:[
      { text: "Premium - 12 (24/7)", value: "Premium - 12 (24/7)", disabled: false },
      { text: "Premium - 8 (24/7)", value: "Premium - 8 (24/7)", disabled: false },
      { text: "Premium - 6 (24/7)", value: "Premium - 6 (24/7)", disabled: false },
      { text: "Premium - 4 (24/7)", value: "Premium - 4 (24/7)", disabled: false },
    ],
    contractTerm:[
      { text: "12", value: "12", disabled: false },
      { text: "24", value: "24", disabled: false },
      { text: "36", value: "36", disabled: false },
    ],
    bandwidth:[
      { text: "10 Mbps", value: "10", disabled: false },
      { text: "20 Mbps", value: "20", disabled: false },
      { text: "30 Mbps", value: "30", disabled: false },
      { text: "40 Mbps", value: "40", disabled: false },

      { text: "50 Mbps", value: "50", disabled: false },
      { text: "60 Mbps", value: "60", disabled: false },
      { text: "70 Mbps", value: "70", disabled: false },
      { text: "80 Mbps", value: "80", disabled: false },

      { text: "90 Mbps", value: "90", disabled: false },
      { text: "100 Mbps", value: "100", disabled: false },
      { text: "150 Mbps", value: "150", disabled: false },
      { text: "200 Mbps", value: "200", disabled: false },

      { text: "250 Mbps", value: "250", disabled: false },
      { text: "300 Mbps", value: "300", disabled: false },
      { text: "350 Mbps", value: "350", disabled: false },
      { text: "400 Mbps", value: "400", disabled: false },

      { text: "450 Mbps", value: "450", disabled: false },
      { text: "500 Mbps", value: "500", disabled: false },
      { text: "600 Mbps", value: "600", disabled: false },
      { text: "700 Mbps", value: "700", disabled: false },

      { text: "800 Mbps", value: "800", disabled: false },
      { text: "900 Mbps", value: "900", disabled: false },
      { text: "1000 Mbps", value: "1000", disabled: false },
    ],
  }),
  methods:{
    submit() {
      let vm = this;
      let payload = {};
      if(vm.record.quoteType.value === "FBCQuoteItem"){
        payload = {
          "quote":{
            "externalId":vm.record.reference,
            "category":"Connect",
            "@type":"EEQuote",
            "productOffering":{
              "id":"TPL900000000001",
              "version":"1.0.0"
            },
            "place":{
              "id":vm.record.locationId
            },
            "quoteItem":[{
              "action":"ADD",
              "@type":"FBCQuoteItem"
            }]
          }
        };

        vm.createQuoteAsync(payload).then((data) => {
          vm.$emit("close", data);
        });
      }else if(vm.record.quoteType.value === "ProductQuoteItem") {
        payload = {
          "quote":{
            "quoteItem": [{
              "action": "ADD",
              "@type": "ProductQuoteItem",
              "product": {
                "name": "Enterprise Ethernet",
                "afterHoursSiteVisit": vm.record.afterHoursSiteVisit.value,
                "serviceRestorationSLA": vm.record.serviceRestorationSLA.value,
                "contractTerm": {
                  "amount": vm.record.contractTerm.value,
                  "unit": "Month"
                },
                "@type": "EEAS"
              }
            }],
            "quoteServiceItem": [{
              "action": "ADD",
              "@type": "ProductQuoteItem",
              "product": {
                "cosLowBandwidth": {
                  "amount": vm.record.cosLowBandwidth.value,
                  "unit": "Mbps"
                },
                "cosMediumBandwidth": {
                  "amount": vm.record.cosMediumBandwidth.value,
                  "unit": "Mbps"
                },
                "cosHighBandwidth": {
                  "amount": vm.record.cosHighBandwidth.value,
                  "unit": "Mbps"
                },
                "@type": "OVC",
                "routeType": vm.record.routeType.value,
                "ovcTransientId": "OVC-1"
              }
            }],
            "quoteResourceItem": [{
              "action": "ADD",
              "@type": "ProductQuoteItem",
              "product": {
                "btdType": "Standard",
                "@type": "BTD",
              }
            }, {
              "action": "ADD",
              "@type": "ProductQuoteItem",
              "product": {
                "interfaceBandwidth": {
                  "amount": "1",
                  "unit": "Gbps"
                },
                "@type": "UNI-E",
              }
            }]
          },
          "quoteID":vm.record.quoteId
        };

        vm.updateQuoteAsync(payload).then((data) => {
          vm.$emit("close", data);
        });
      }
    }
  },
  computed: {
    isProductQuote() {
      let vm = this;
      if(vm.record.quoteType != null && vm.record.quoteType.value === "ProductQuoteItem")
      {
        return true;
      }else{
        return false;
      }
    },
  },
  beforeMount() {
    let vm=this;
    if(vm.isEditing)
    {
      vm.record = vm.query;
    }
  },
}
</script>

<style scoped>

</style>
